import React, { useState, useEffect } from "react";
import "./App.scss";
import Button from "./components/commons/button/Button";
import SectionFooter from "./components/section/footer/Footer";
import SectionProfitability from "./components/section/profitability/Profitability";
import SectionRanking from "./components/section/ranking/Ranking";
import SectionFunds from "./components/section/funds/Funds";
import SectionRent from "./components/section/rent/Rent";
import SectionInverment from "./components/section/inverment/Inverment";
import SectionPorfolio from "./components/section/porfolio/Porfolio";
import GeneralService from "./services/general-service";

const App = () => {
    const generalService = new GeneralService();
    const [data, setData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const respuesta = await generalService.getGeneralData();
            const feeInputResponse = await generalService.getFeeInputs();

            if (respuesta && feeInputResponse) {
                setData(respuesta);
                setYears(feeInputResponse.years);
                setMonths(feeInputResponse.months);
                setIsLoading(false);

                setTimeout(() => {
                    if (window.parent && window.parent.document.getElementById("graficos")) {
                        window.parent.valorescuota_iFrameHeight();
                    }
                  }, 1000); 
            }
        };

        fetchData();

        return () => {
            generalService.cancelRequests();
        };
    }, []);

    const publicity0 = {
        text: "Revisa los valores cuota en el siguiente link:",
        btnText: "Ir a la SBS",
        btnLink: "https://www.sbs.gob.pe/app/stats_net/stats/EstadisticaSistemaFinancieroResultados.aspx?c=FP-1359",
    };
    const publicity1 = {
        text: data.grafico1 ? data.grafico1.information.publicity.name : "",
        btnText: data.grafico1 ? data.grafico1.information.publicity.btnChange.name : "",
        btnLink: data.grafico1 ? data.grafico1.information.publicity.btnChange.link : "",
    };

    const publicity3 = {
        text: data.grafico3 ? data.grafico3.information.publicity.desktop.name : "",
        btnText: data.grafico3 ? data.grafico3.information.publicity.desktop.btnChange.name : "",
        btnLink: data.grafico3 ? data.grafico3.information.publicity.desktop.btnChange.link : "",
    };

    const publicity32 = {
        text: data.grafico3 ? data.grafico3.information.publicity.mobile.name : "",
        btnText: data.grafico3 ? data.grafico3.information.publicity.mobile.btnChange.name : "",
        btnLink: data.grafico3 ? data.grafico3.information.publicity.mobile.btnChange.link : "",
    };

    const publicity5 = {
        text: data.grafico5 ? data.grafico5.information.publicity.name : "",
        btnText: data.grafico5 ? data.grafico5.information.publicity.btnChange.name : "",
        btnLink: data.grafico5 ? data.grafico5.information.publicity.btnChange.link : "",
    };

    const publicity6 = {
        title: data.grafico6 ? data.grafico6.information.publicity.title : "",
        text: data.grafico6 ? data.grafico6.information.publicity.name : "",
        btnText: data.grafico6 ? data.grafico6.information.publicity.btnChange.name : "",
        btnLink: data.grafico6 ? data.grafico6.information.publicity.btnChange.link : "",
    };

    if (isLoading) {
        return (
            <section className="loader">
                <div id="ld3">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <p>cargando</p>
            </section>
        );
    }

    return (
        <main className="bg-body">
            <SectionProfitability {...data.grafico1} />
            <SectionFooter
                theme="light full-device light-1"
                text={publicity0.text}
                action={<Button text={publicity0.btnText} url={publicity0.btnLink} />}
            />
            <SectionFooter
                theme="dark dark-1"
                text={publicity1.text}
                action={<Button text={publicity1.btnText} url={publicity1.btnLink} />}
            />
            {/* <ViewValorCuota years={years} months={months} periods={years}>
                    {tagDescription()}
                </ViewValorCuota> */}

            <SectionRanking {...data.grafico2} />
            <SectionFunds {...data.grafico3} />
            <div className={"show-desktop"}>
                <SectionFooter
                    theme="dark dark-2"
                    text={publicity3.text}
                    action={<Button text={publicity3.btnText} url={publicity3.btnLink} />}
                />
            </div>
            <div className={"show-mobile"}>
                <SectionFooter
                    theme="dark dark-2"
                    text={publicity32.text}
                    action={<Button text={publicity32.btnText} url={publicity32.btnLink} />}
                />
            </div>

            <SectionRent {...data.grafico4} />
            <SectionInverment {...data.grafico5} />

            <SectionFooter
                theme="light full-device light-1"
                text={publicity5.text}
                action={
                    <Button
                        text={publicity5.btnText}
                        url={publicity5.btnLink}
                        icon="icohbi-download"
                    />
                }
            />
            <SectionFooter
                theme="light full-movil light-1"
                text=""
                action={
                    <Button
                        text="Descarga el informe de Instrumentos de Inversión de AFP Habitat"
                        icon="icohbi-download"
                    />
                }
            />
            <SectionPorfolio {...data.grafico6} />
            <SectionFooter
                theme="light full-device-movile light-2"
                title={publicity6.title}
                text={publicity6.text}
                action={
                    <Button
                        text={publicity6.btnText}
                        url={publicity6.btnLink}
                        icon="icohbi-download"
                    />
                }
            />
            <SectionFooter
                theme="light full-movil light-1"
                text=""
                action={
                    <Button
                        text={publicity6.text}
                        url={publicity6.btnLink}
                        icon="icohbi-download"
                    />
                }
            />
            {/* <SectionMain>
          <div className="row period align-items-center justify-content-center">
            <div className="col hbi-right">{tagDescription()}</div>
            <div className="col hbi-left">
              <div className="hbi-row">
                <h2 className="hbi-title">Periodo</h2>
              </div>
              <div className="hbi-row form-row">
                <div className="col">
                  <Select
                    name="year"
                    options={years}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col">
                  <Select
                    name="month"
                    options={months}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="col">
                  <Button
                    theme="btn-block"
                    text="Aceptar"
                    onClick={this.fetchFeeValue}
                  />
                </div>
              </div>
              <div className="hbi-row">
                <p className="hbi-help-text">{periods.requireText}</p>
              </div>
            </div>
          </div>
        </SectionMain> */}
            {/* <FeeValue
          content={feeValue}
          isLoading={isLoadingFeeValue}
          month={this.state.month}
          year={this.state.year}
        /> */}
            <SectionFooter
                theme="dark dark-1"
                text={data.periods?.publicity?.name}
                action={
                    <Button
                        text={data.periods?.publicity?.btnChange?.name}
                        url={data.periods?.publicity?.btnChange?.link}
                    />
                }
            />
        </main>
    );
}

export default App;
